import { jsx as _jsx } from "react/jsx-runtime";
import { DrawerContextProvider } from '../../context';
import { DrawerContainer } from './DrawerContainer';
/**
 * DrawerComponent component
 *
 * This component wraps the DrawerContainer component and provides a drawer context for the children.
 * @param {DrawerComponentProps} props
 */
export const DrawerComponent = ({ children, containerProps, ...contextProps }) => {
    return (_jsx(DrawerContextProvider, { ...contextProps, children: _jsx(DrawerContainer, { ...containerProps, children: children }) }));
};
